<template>
  <section class="parking-complex-list">
    <div class="parking-complex-list__actions">
      <CamsButton
        class="parking-complex-list__action"
        type="button"
        @click="$emit('create')"
      >
        <img src="@/assets/img/icons/icon-add.svg" alt="">
        <span>Создать парковочный комплекс</span>
      </CamsButton>

      <CamsButton
        v-if="complexes.length"
        class="parking-complex-list__action parking-complex-list__map-button"
        :class="{'is-active': isMapVisible}"
        type="button"
        :aria-pressed="String(isMapVisible)"
        @click="toggleMap"
      >
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <path d="M12 21s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12Z" />
          <circle cx="12" cy="9" r="2.5" />
        </svg>
        <span>Карта</span>
      </CamsButton>
    </div>

    <ParkingComplexMap
      v-if="isMapVisible && complexes.length"
      :complexes="complexes"
      :expanded-complex-id="expandedComplexId"
      :selected-parking-id="selectedParkingId"
      @toggle-complex="$emit('toggle-complex', $event)"
      @edit-parking="$emit('edit-parking', $event)"
      @delete-parking="$emit('delete-parking', $event)"
    />

    <template v-else>
      <h2 class="parking-complex-list__title">
        Парковочные комплексы
      </h2>

      <div v-if="complexes.length" class="parking-complex-list__grid">
        <ParkingComplexCard
          v-for="parkingComplex in complexes"
          :key="parkingComplex.id || parkingComplex.name"
          :complex="parkingComplex"
          :expanded="parkingComplex.id === expandedComplexId"
          @toggle="$emit('toggle-complex', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
        />
      </div>

      <ParkingEmptyState
        v-else
        class="parking-complex-list__empty"
        description="Создайте парковочный комплекс для аналитики парковочных мест"
      />

      <div v-if="expandedComplex" class="parking-complex-list__details">
        <h2 class="parking-complex-list__title">
          Парковки
        </h2>

        <div v-if="expandedParkings.length" class="parking-complex-list__parking-grid">
          <ParkingSummaryCard
            v-for="parking in expandedParkings"
            :key="parking.id || parking.name"
            :parking="parking"
            :selected="parking.id === selectedParkingId"
            @select="$emit('select-parking', $event)"
            @edit="$emit('edit-parking', {parkingComplex: expandedComplex, parking: $event})"
            @delete="$emit('delete-parking', {parkingComplex: expandedComplex, parking: $event})"
          />
        </div>

        <p v-else class="parking-complex-list__no-parkings">
          В комплексе пока нет парковок
        </p>

        <TableParkingDetectionAnalytics
          v-if="selectedParking"
          :cameras="parkingCameras"
          :loading="parkingCamerasLoading"
          :parking="selectedParking"
          @updated="$emit('camera-updated', $event)"
        />
      </div>
    </template>
  </section>
</template>

<script>
import ParkingComplexCard from "@/components/pacs/analytics/parkingDetection/ParkingComplexCard.vue";
import ParkingComplexMap from "@/components/pacs/analytics/parkingDetection/ParkingComplexMap.vue";
import ParkingEmptyState from "@/components/pacs/analytics/parkingDetection/ParkingEmptyState.vue";
import ParkingSummaryCard from "@/components/pacs/analytics/parkingDetection/ParkingSummaryCard.vue";
import TableParkingDetectionAnalytics from "@/components/pacs/analytics/parkingDetection/TableParkingDetectionAnalytics.vue";

/**
 * Список парковочных комплексов.
 */
export default {
  name: "ParkingComplexList",
  components: {
    ParkingComplexCard,
    ParkingComplexMap,
    ParkingEmptyState,
    ParkingSummaryCard,
    TableParkingDetectionAnalytics,
  },
  props: {
    complexes: {
      type: Array,
      default: () => [],
    },
    expandedComplexId: {
      type: [Number, String],
      default: null,
    },
    selectedParkingId: {
      type: [Number, String],
      default: null,
    },
    parkingCameras: {
      type: Array,
      default: () => [],
    },
    parkingCamerasLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMapVisible: false,
    };
  },
  computed: {
    expandedComplex() {
      return this.complexes.find(
        parkingComplex => parkingComplex.id === this.expandedComplexId
      ) || null;
    },
    expandedParkings() {
      return this.expandedComplex && Array.isArray(this.expandedComplex.parkings)
        ? this.expandedComplex.parkings
        : [];
    },
    selectedParking() {
      if (!this.expandedComplex) return null;
      return this.expandedParkings.find(
        parking => parking.id === this.selectedParkingId
      ) || null;
    },
  },
  methods: {
    toggleMap() {
      this.isMapVisible = !this.isMapVisible;
      if (this.isMapVisible && this.expandedComplexId === null && this.complexes.length) {
        this.$emit("toggle-complex", this.complexes[0]);
      }
    },
  },
};
</script>
